import Button from "../../../componentsNew/Button";
import { CampoInputBase } from "../../../componentsNew/Input/CampoInput/CampoInputBase";
import HeaderTable from "../../../componentsNew/Table/HeaderTable";
import ItemTable from "../../../componentsNew/Table/ItemTable";
import Typography from "../../../componentsNew/Typography";
import star from "../../../assets/img/stars-02.svg"
import Card from "../../../componentsNew/Card";
import Select from "../../../componentsNew/Select";
import { IoIosArrowDown } from "react-icons/io";
import { ObterAvaliacaoPalavraChave } from "@api/controllers/optiGenerator";
import { toast } from "react-toastify";
import { useEffect, useState } from "@wordpress/element";
import SemDadosAnalise from "@pages/DicasOtimizacao/AnalisesTextuais/Components/SemDadosAnalise";
import CircularProgress from "@componentsNew/CircularProgress";

export function StepPalavraChave({ setErroNext, form, mudarValor }) {

    const [erro, setErro] = useState(false)
    const [loading, setLoading] = useState(false)

    function avaliarPalavraChave() {
        setErro(false)
        setLoading(true)
        if (form.palavraChave.trim() === "") {
            toast.error("Digite a palavra chave!")
            return
        }

        ObterAvaliacaoPalavraChave(form.palavraChave).then(res => {
            if (!res.data.reFsults) {
                setErro(true)
                setErroNext(true)
            }
            setPalavras(res.data.results)
            setLoading(false)
            setErroNext(false)
        })
    }

    useEffect(() => {
        if(form.palavraChave.trim() === "") {
            setErroNext(true)
        }else{
            setErroNext(false)
        }
    },[form.palavraChave])

    useEffect(() => {
        setErroNext(true)
    },[])

    const [palavras, setPalavras] = useState([])

    return (
        <>
            <Card className="px-4 py-3 text-center !shadow-[0px_5px_4px_0px_rgba(0,0,0,0.20)]">
                <Typography component="body-secundary-bold">Digite sua palavra-chave principal e avalie para continuar com sua criação</Typography>
            </Card>
            <Select
                className="mt-8"
                component="active"
                valorInput={form.intencaoPalavraChave}
                setValorInput={e => mudarValor("intencaoPalavraChave", e)}
                label="Intenção da Palavra-chave"
                icon={<IoIosArrowDown className="w-4 text-text-secundary" />}
                opcoes={[
                    { valor: 'Informativa', titulo: 'Informativa' },
                    { valor: 'Comercial', titulo: 'Comercial' },
                    { valor: 'Transacional', titulo: 'Transacional' },
                    { valor: 'Educacional', titulo: 'Educacional' },
                    { valor: 'Navegacional', titulo: 'Navegacional' }
                ]}
            //carregando={carregando}
            //desabilidato={desabilidato}
            //renderValue={renderValue}
            //checkbox={checkbox} 
            />
            <CampoInputBase
                className={"mt-8"}
                label="Palavra-chave Principal"
                valor={form.palavraChave}
                setValor={e => mudarValor("palavraChave", e)}
            />
            <div className="flex justify-end w-full">
                <Button onClick={() => avaliarPalavraChave()} className="w-3/5 mt-8"><Typography component="button">Avaliar Palavra-chave</Typography></Button>
            </div>
            <div className="my-2 pt-8">
                <table className="w-full table-auto flex flex-col divide-y divide-fundo-borda-grafico text-left">
                    <thead className="pb-6 w-full">
                        <tr className="flex bg-neutras-grey-light rounded-lg py-2 px-6 uppercase gap-12 text-text-primary">
                            <HeaderTable style={{ fontSize: '10px' }} className="text-xs w-3/6">PALAVRA-CHAVE</HeaderTable>
                            <HeaderTable className="text-xs w-2/6">VOLUME DE BUSCA</HeaderTable>
                        </tr>
                    </thead>
                    <tbody className="w-full">
                        {loading && <div className="flex flex-col items-center">
                            <CircularProgress className="mt-8" />
                            <p className="text-center mt-4">Buscando...</p>
                        </div>}

                        {!loading && palavras && palavras?.length > 0 ? palavras?.map(m => <tr
                            onClick={() => mudarValor("palavraChave", m?.text)}
                            className={`flex mb-4 cursor-pointer px-6 py-[0.625rem] gap-12 
                                    ${form.palavraChave === m?.text
                                    ? 'border-solid border-2 border-[#56a55c] rounded-xl'
                                    : 'hover:border-solid hover:border-2 hover:border-[#56a55c] hover:rounded-xl'}`}
                        >
                            <ItemTable className="w-3/6">{m?.text}</ItemTable>
                            <ItemTable className="w-2/6">{m?.keywordIdeaMetrics?.avgMonthlySearches}</ItemTable>
                        </tr>)
                            : <tr className="min-h-[15.438em] items-center justify-center flex h-full">
                                {!loading && <td><SemDadosAnalise texto={erro ? "Não utilize termos inapropriados, tente novamente com outra palavra-chave." : "Adicione uma palavra-chave para iniciar avaliação das palavras vinculadas"} /></td>}
                            </tr>}
                    </tbody>
                </table>
            </div>
        </>
    )
}